import React from 'react';
import ProformaProjectFormsSettings from '@atlassian/jira-proforma-project-forms-settings/src/ui/index.tsx';
import type { ProjectContext } from '@atlassian/jira-router-resources-project-context/src/services/project-context/types.tsx';
import AppContainer from '@atlassian/jira-spa-apps-project-settings-common/src/components/app-container.tsx';
import { SharedSettingsDocumentTitle } from '@atlassian/jira-spa-apps-project-settings-common/src/shared-document-title/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';

export type Props = {
	projectContext: ProjectContext;
};

const ProformaProjectFormsSettingsWrapper = ({ projectContext }: Props) => (
	<UFOSegment name="proforma-project-forms-settings-wrapper">
		<SharedSettingsDocumentTitle
			projectName={projectContext.projectName}
			section="proformaForms"
			projectType={projectContext.projectType}
		/>
		<AppContainer baseUrl="" projectKey={projectContext.projectKey}>
			<ProformaProjectFormsSettings />
		</AppContainer>
	</UFOSegment>
);

export default ProformaProjectFormsSettingsWrapper;
